export const grid = {
  breakpoint_sm: '768',
  breakpoint_md: '1224',
  breakpoint_lg: '1280',
  breakpoint_xl: '1512',
};
